import { render, staticRenderFns } from "./DocumentScanner.vue?vue&type=template&id=230a7030&scoped=true&"
import script from "./DocumentScanner.vue?vue&type=script&lang=js&"
export * from "./DocumentScanner.vue?vue&type=script&lang=js&"
import style0 from "./DocumentScanner.vue?vue&type=style&index=0&id=230a7030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a7030",
  null
  
)

export default component.exports